export default __webpack_public_path__ + "static/media/linkedin.668fe687.png";